import { blue, green, red, yellow, neutral, gray } from './colors';
import { primaryFont, fontWeight, typeScale } from './typography';
export var defaultTheme = {
  colors: {
    primary: {
      "default": blue[200],
      hover: neutral[100],
      active: blue[100],
      textColor: neutral[100]
    },
    secondary: {
      "default": blue[200],
      hover: neutral[100],
      active: blue[100],
      textColor: neutral[100]
    },
    tertiary: {
      "default": neutral[600],
      hover: neutral[200],
      active: neutral[300],
      textColor: neutral[600]
    }
  },
  primaryColor: blue[200],
  primaryHoverColor: neutral[100],
  primaryActiveColor: blue[200],
  primaryBackground: blue[100],
  secondaryColor: blue[300],
  tertiaryColor: blue[400],
  textColorOnPrimary: neutral[100],
  primaryBackgroundColor: blue[75],
  textColor: neutral[600],
  textColorInverted: neutral[100],
  primaryFont: primaryFont,
  tertiaryHoverColor: neutral[200],
  textHoverColor: neutral[200],
  primaryFontWeight: fontWeight['primary'],
  disabled: neutral[200],
  textOnDisabled: neutral[400],
  textFieldBackground: neutral[200],
  textFieldLabelColor: neutral[500],
  labelColor: neutral[600],
  lightBullet: gray[400],
  labelBackgroundColor: neutral[200],
  primaryBorder: neutral[300],
  primaryBorderActive: blue[200],
  border: neutral[200],
  backgroundLight: neutral[200],
  background: neutral[100],
  shadow: gray[100],
  status: {
    warningColor: yellow[200],
    warningColorHover: yellow[300],
    save: blue[50],
    cancel: gray[200],
    warningColorActive: yellow[200],
    errorColor: red[200],
    errorColorHover: red[300],
    errorColorActive: red[300],
    successColor: green[200],
    successColorHover: green[300],
    successColorActive: green[300]
  },
  text: {
    "default": neutral[600],
    inactive: neutral[200],
    bodyText: neutral[300],
    bodyTextLight: neutral[400],
    bodyTextDark: neutral[500],
    iconLabel: gray[300],
    primary: blue[200],
    white: neutral[100],
    warning: yellow[200],
    error: red[200],
    success: green[200]
  },
  typeScale: typeScale,
  fontWeight: fontWeight
};